var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('device-list',{staticClass:"device-list",attrs:{"show-nested":true,"fn-click-item":_vm.selectDevice}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }